import React from "react";

/** Matches tile subtitle formatting in CourseCategory IntroPart Tiles.jsx */
export function formatQuizLicenseLabel(heading) {
    if (!heading || typeof heading !== "string") return "";
    const h = heading.trim();
    if (
        h === "M, M1, or M2 with condition 1 (motor tricycle)" ||
        h === "M, M1, or M2 with condition L (LSM/moped)"
    ) {
        return h;
    }
    return `${h} License`;
}

/** Full-width hero under the site nav — gradient per Figma (70deg, #170654 → #440F88). */
function KnowledgeTestQuizPageHeader({
    licenseLabel,
    questionCount,
    title,
    subtitle,
}) {
    const heading = title && String(title).trim() ? String(title).trim() : "Knowledge Test Quiz";
    const label =
        licenseLabel && String(licenseLabel).trim()
            ? String(licenseLabel).trim()
            : "License category";
    const count =
        questionCount != null && Number.isFinite(Number(questionCount))
            ? Number(questionCount)
            : null;
    const line2 =
        subtitle && String(subtitle).trim()
            ? String(subtitle).trim()
            : count != null
            ? `${label} | ${count} Random Questions`
            : `${label} | Random Questions`;

    return (
        <div
            className="w-full py-8 px-5 md:py-10"
            style={{
                background:
                    "transparent linear-gradient(70deg, #170654 0%, #440F88 100%) 0% 0% no-repeat padding-box",
            }}
        >
            <div className="mx-auto flex w-[90%] max-w-6xl flex-col items-start gap-2 text-left lg:w-[85%]">
                <h1
                    className="m-0 text-left font-bold tracking-normal text-white opacity-100 text-[45px] leading-[60px]"
                    style={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontStyle: "normal",
                    }}
                >
                    {heading}
                </h1>
                <p
                    className="m-0 text-left font-normal text-white text-[32px] leading-[43px]"
                    style={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontStyle: "normal",
                    }}
                >
                    {line2}
                </p>
            </div>
        </div>
    );
}

export default KnowledgeTestQuizPageHeader;
